import { Component, ErrorInfo, ReactNode } from 'react'
import * as Sentry from '@sentry/browser'

type Props = {
  fallback: (error: Error, reset: () => void) => NonNullable<ReactNode>
}

type State = {
  error?: Error
}

class ErrorBoundary extends Component<Props, State> {
  state: State = {}

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    Sentry.withScope(scope => {
      scope.setExtras((errorInfo as unknown) as Record<string, unknown>)
      Sentry.captureException(error)
    })
  }

  render() {
    const { fallback, children } = this.props
    const { error } = this.state
    const reset = () => this.setState({ error: undefined })
    return error ? fallback(error, reset) : children
  }
}

export default ErrorBoundary
